import React, { useEffect, useState } from "react";
import ContextMenu from "../ContextMenu/ContextMenu";
import { MenuItem, MenuList, Paper } from "@mui/material";
import { t } from "i18next";

const CommonGridContextMenu = ({pasteHandler, targetId}) => {
  const [enableCopy, setEnableCopy] = useState(false);
  const [copyContent, setCopyContent] = useState('');

  const copyHandler = async () => {
    const copyStatus = await navigator.clipboard.writeText(copyContent);
  }

  const selectionHandler = () => {
    const text = window?.getSelection()?.toString();
    if(text !== '') {
      setEnableCopy(true);
      setCopyContent(text);
    }
    else setEnableCopy(false);
  }

  useEffect(() => {
    window.addEventListener('selectionchange',selectionHandler)
    window.addEventListener('mouseup',selectionHandler)
    return () => {
      window.removeEventListener('selectionchange',selectionHandler)
      window.removeEventListener('mouseup',selectionHandler)
    }
  },[])

  return (
    <ContextMenu  targetId={targetId}>
      <Paper  elevation={3} sx={{ width: "19rem" }}>
        <MenuList>
          <MenuItem className ={"ag-cell"} disabled={!enableCopy} name={t("MNU_COPY")} onClick={copyHandler}>
            <span className={"COPY"}></span>
            <span className={"margin-left-8"}>{t("MNU_COPY")}</span>
          </MenuItem>
          <MenuItem name={t("MNU_PASTE")} onClick={pasteHandler}>
            <span className={"DOCUMENT"}></span>
            <span className={"margin-left-8"}>{t("MNU_PASTE")}</span>
          </MenuItem>
        </MenuList>
      </Paper>
    </ContextMenu>
  );
};

export default CommonGridContextMenu;
